import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const fiatAccountApi = {
  getAnnuouncement(query) {
    return http.get(API_URLS.PUBLIC_B2C_BANNER, {
      query,
      formatter: (data) => {
        return (data.items && data.items[0]) || {};
      },
    });
  },
  getAnnuouncements(query) {
    return http.get(API_URLS.PUBLIC_B2C_BANNER, {query});
  },
  getFiatBalanceQuery(query) {
    return http.get(API_URLS.FIAT_BALANCE_QUERY, {query});
  },
  getFiatDepositConfig(query) {
    return http.get(API_URLS.PUBLIC_FIAT_DEPOSIT_CONFIG, {query});
  },
  getFiatDepositAccount(query) {
    return http.get(API_URLS.FIAT_DEPOSIT_ACCOUNT_QUERY, {query});
  },
  fiatDepositSuccessConfirm(query) {
    return http.post(API_URLS.FIAT_DEPOSIT_SUCCESS_CONFIRM, {query});
  },
  getFiatDepositQuery(query) {
    return http.get(API_URLS.FIAT_DEPOSIT_QUERY, {query});
  },
  getFiatDepositWithdrawConfig(query) {
    return http.get(API_URLS.FIAT_DEPOSIT_WITHDRAW_QUERY, {query});
  },
  getFiatWithdrawCards(query) {
    return http.get(API_URLS.FIAT_DEPOSIT_WITHDRAW_CARDS, {query});
  },
  fiatDepositWithdrawSubmit(params) {
    return http.post(API_URLS.FIAT_DEPOSIT_WITHDRAW_SUBMIT, {params});
  },
  getFiatWithdrawOrderList(query) {
    return http.get(API_URLS.FIAT_WITHDRAW_ORDER_LIST, {query});
  },
  fiatBalanceChangeQuery(query) {
    return http.get(API_URLS.FIAT_BALANCE_CHANGE_QUERY, {query});
  },
  getOneClickConfig(query) {
    return http.get(API_URLS.OC_CONFIG, {query});
  },
  getOneClickPricing(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_PRICING : API_URLS.PUBLIC_BUY_CRYPTO_PRICING, {query});
  },
  fiatOrder(params) {
    return http.post(API_URLS.OC_FIAT_ORDER, {params});
  },
  thirdPartyOrder(query) {
    return http.post(API_URLS.BUY_CRYPTO_PLACE_ORDER, {query});
  },
  thirdPartyGoogleApplePayOrder(params) {
    return http.post(API_URLS.BUY_CRYPTO_PLACE_ORDER_GOOGLE_APPLE_PAY, {params});
  },
  getChannels(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_CONFIG : API_URLS.PUBLIC_BUY_CRYPTO_CONFIG, {query});
  },
  placeOrder(params) {
    return http.post(API_URLS.OC_PLACE_ORDER, {params});
  },
  checkSellRisk(params) {
    return http.post(API_URLS.OC_RISK_CHECK, {params});
  },
  postKycValidate(params) {
    return http.post(API_URLS.OC_KYC_VALIDATE, {params});
  },
  createTransakOrder(params) {
    return http.post(API_URLS.OC_TRANSAK_ORDER, {params});
  },
  saveTransakOrder(query) {
    return http.get(API_URLS.OC_TRANSAK_SAVE_ORDER, {query});
  },
  getFiatDepositOrderList(query) {
    return http.get(API_URLS.FIAT_DEPOSIT_ORDER_LIST, {query});
  },
  postDepositConfirm(query) {
    return http.post(API_URLS.FIAT_DEPOSIT_CONFIRM, {query});
  },
  getFiatBizGary(query) {
    return http.get(API_URLS.FIAT_BIZ_GARY, {query});
  },
  getFiatBalanceOrderList(query) {
    return http.get(API_URLS.OC_FIAT_BALANCE_HISTORY, {query});
  },
  getCreditDebitCardOrderList(query) {
    return http.get(API_URLS.OC_CREDIT_DEBIT_CARD_HISTORY, {query});
  },
  getThirdPartyOrderList(query) {
    return http.get(API_URLS.OC_THIRD_PARTY_HISTORY, {query});
  },
  getDefaultPaymentMethod() {
    return http.get(API_URLS.OC_DEFAULT_PAYMENT_METHOD, {});
  },
  bindSellCreditDebitCard(params) {
    return http.post(API_URLS.OC_CREDIT_DEBIT_BIND_CARD, {params});
  },
  getNewCardDetail(query) {
    return http.get(API_URLS.OC_NEW_CARD_DETAIL, {query});
  },
  fiatDepositConfirm(params) {
    return http.post(API_URLS.OC_FIAT_DEPOSIT_CONFIRM, {params});
  },
};
